import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const lineKey = (productId, color, size) => `${productId}__${color || ""}__${size || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("nesta_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("nesta_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, options = {}) => {
    const color = options.color || "";
    const size = options.size || "";
    const key = lineKey(product.id, color, size);
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found)
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + quantity } : i));
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          name: product.name,
          price: options.price != null ? options.price : product.price,
          image: options.image || product.image,
          color,
          size,
          size_label: options.size_label || "Size",
          quantity,
        },
      ];
    });
  };

  const updateQty = (key, quantity) => {
    if (quantity < 1) return;
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));

  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clearCart, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
